import { useEffect, useRef } from 'react';
import { useGameStore } from '../game/store';
import { BIOME_DISPLAY, BIOME_ORDER } from '../game/engine/types';

function drawMiniObstacle(
  canvas: HTMLCanvasElement,
  type: string,
  color: string,
): void {
  const ctx = canvas.getContext('2d')!;
  const w = canvas.width;
  const h = canvas.height;
  ctx.clearRect(0, 0, w, h);
  ctx.fillStyle = color;

  switch (type) {
    case 'GATE':
      ctx.fillRect(0, h * 0.1, w * 0.35, h * 0.8);
      ctx.fillRect(w * 0.65, h * 0.1, w * 0.35, h * 0.8);
      ctx.fillStyle = '#40ffc0';
      ctx.fillRect(w * 0.35, h * 0.35, w * 0.3, h * 0.3);
      break;
    case 'PULSE_WALL':
      ctx.fillRect(0, h * 0.2, w * 0.3, h * 0.6);
      ctx.fillRect(w * 0.7, h * 0.2, w * 0.3, h * 0.6);
      ctx.fillStyle = '#40ffc0';
      ctx.fillRect(w * 0.3, h * 0.35, w * 0.4, h * 0.3);
      break;
    case 'DOUBLE_GATE':
      ctx.fillRect(0, h * 0.1, w * 0.35, h * 0.35);
      ctx.fillRect(0, h * 0.55, w * 0.35, h * 0.35);
      ctx.fillRect(w * 0.65, h * 0.1, w * 0.35, h * 0.35);
      ctx.fillRect(w * 0.65, h * 0.55, w * 0.35, h * 0.35);
      ctx.fillStyle = '#40ffc0';
      ctx.fillRect(w * 0.35, h * 0.1, w * 0.3, h * 0.35);
      ctx.fillRect(w * 0.35, h * 0.55, w * 0.3, h * 0.35);
      break;
    case 'LOG':
      ctx.save();
      ctx.translate(w * 0.5, h * 0.5);
      ctx.rotate(Math.PI / 6);
      ctx.fillStyle = color;
      ctx.fillRect(-w * 0.15, -h * 0.35, w * 0.3, h * 0.7);
      ctx.restore();
      break;
    case 'CORAL_SPIRE':
      ctx.fillRect(w * 0.3, h * 0.1, w * 0.15, h * 0.8);
      ctx.fillRect(w * 0.55, h * 0.2, w * 0.15, h * 0.7);
      break;
    case 'JELLYFISH':
      ctx.beginPath();
      ctx.arc(w * 0.5, h * 0.3, w * 0.3, Math.PI, 0);
      ctx.fill();
      ctx.strokeStyle = color;
      ctx.lineWidth = 2;
      for (let i = 0; i < 4; i++) {
        const x = w * 0.25 + i * w * 0.17;
        ctx.beginPath();
        ctx.moveTo(x, h * 0.35);
        ctx.quadraticCurveTo(x + 5, h * 0.6, x, h * 0.9);
        ctx.stroke();
      }
      break;
    case 'BEEHIVE':
      ctx.beginPath();
      ctx.arc(w * 0.5, h * 0.5, w * 0.35, 0, Math.PI * 2);
      ctx.stroke();
      for (let i = 0; i < 6; i++) {
        const angle = (i / 6) * Math.PI * 2;
        const x = w * 0.5 + Math.cos(angle) * w * 0.25;
        const y = h * 0.5 + Math.sin(angle) * h * 0.25;
        ctx.beginPath();
        ctx.arc(x, y, 4, 0, Math.PI * 2);
        ctx.fill();
      }
      break;
    case 'KELP_CURTAIN':
      ctx.fillRect(0, h * 0.1, w * 0.25, h * 0.8);
      ctx.fillRect(w * 0.35, h * 0.1, w * 0.15, h * 0.8);
      ctx.fillRect(w * 0.65, h * 0.1, w * 0.35, h * 0.8);
      ctx.fillStyle = '#40ffc0';
      ctx.fillRect(w * 0.25, h * 0.35, w * 0.1, h * 0.3);
      break;
    case 'DIAGONAL_BEAM':
      ctx.save();
      ctx.translate(w * 0.5, h * 0.5);
      ctx.rotate(Math.PI / 4);
      ctx.fillRect(-w * 0.4, -h * 0.08, w * 0.8, h * 0.16);
      ctx.restore();
      break;
    case 'PORTAL_WALL':
      ctx.fillStyle = '#202844';
      ctx.fillRect(0, h * 0.1, w * 0.35, h * 0.8);
      ctx.fillRect(w * 0.55, h * 0.1, w * 0.45, h * 0.8);
      ctx.fillStyle = '#40ffc0';
      ctx.fillRect(w * 0.35, h * 0.1, w * 0.2, h * 0.8);
      break;
    case 'CROSS_GATE':
      ctx.save();
      ctx.translate(w * 0.5, h * 0.5);
      ctx.rotate(Math.PI / 4);
      ctx.fillRect(-w * 0.4, -h * 0.06, w * 0.8, h * 0.12);
      ctx.fillRect(-h * 0.06, -w * 0.4, h * 0.12, w * 0.8);
      ctx.restore();
      break;
    case 'SHIFTING_WALL':
      ctx.fillStyle = '#202844';
      ctx.fillRect(0, h * 0.1, w * 0.3, h * 0.8);
      ctx.fillRect(w * 0.6, h * 0.1, w * 0.4, h * 0.8);
      ctx.fillStyle = '#40ffc0';
      ctx.fillRect(w * 0.3, h * 0.1, w * 0.3, h * 0.8);
      break;
    case 'CHAOS_RING':
      ctx.fillStyle = '#202844';
      ctx.fillRect(0, h * 0.15, w * 0.35, h * 0.25);
      ctx.fillRect(w * 0.55, h * 0.15, w * 0.45, h * 0.25);
      ctx.fillRect(0, h * 0.6, w * 0.25, h * 0.25);
      ctx.fillRect(w * 0.65, h * 0.6, w * 0.35, h * 0.25);
      ctx.fillStyle = '#40ffc0';
      ctx.fillRect(w * 0.35, h * 0.15, w * 0.2, h * 0.25);
      ctx.fillRect(w * 0.25, h * 0.6, w * 0.4, h * 0.25);
      break;
    case 'COMET':
      ctx.fillStyle = '#ff4a30';
      ctx.beginPath();
      ctx.arc(w * 0.35, h * 0.5, w * 0.2, 0, Math.PI * 2);
      ctx.fill();
      ctx.strokeStyle = '#40ffc0';
      ctx.lineWidth = 3;
      ctx.beginPath();
      ctx.moveTo(w * 0.35, h * 0.5);
      ctx.lineTo(w * 0.85, h * 0.5);
      ctx.stroke();
      break;
  }
}

function drawMiniFood(canvas: HTMLCanvasElement, type: string): void {
  const ctx = canvas.getContext('2d')!;
  const w = canvas.width;
  const h = canvas.height;
  ctx.clearRect(0, 0, w, h);

  switch (type) {
    case 'NORMAL':
      ctx.fillStyle = '#ffe640';
      ctx.beginPath();
      ctx.arc(w * 0.5, h * 0.5, w * 0.3, 0, Math.PI * 2);
      ctx.fill();
      break;
    case 'GOLDEN':
      ctx.fillStyle = '#ffd700';
      ctx.beginPath();
      ctx.arc(w * 0.5, h * 0.5, w * 0.35, 0, Math.PI * 2);
      ctx.fill();
      ctx.fillStyle = '#fff';
      ctx.font = `bold ${w * 0.4}px sans-serif`;
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';
      ctx.fillText('★', w * 0.5, h * 0.5);
      break;
  }
}

function ObstacleLegendItem({ type, label, desc, color }: { type: string; label: string; desc: string; color: string }) {
  const canvasRef = useRef<HTMLCanvasElement>(null);
  useEffect(() => {
    if (canvasRef.current) {
      drawMiniObstacle(canvasRef.current, type, color);
    }
  }, [type, color]);
  return (
    <li className="legend-item">
      <canvas ref={canvasRef} width={40} height={30} className="legend-canvas" />
      <span className="legend-text"><strong>{label}</strong> — {desc}</span>
    </li>
  );
}

function FoodLegendItem({ type, label, desc }: { type: string; label: string; desc: string }) {
  const canvasRef = useRef<HTMLCanvasElement>(null);
  useEffect(() => {
    if (canvasRef.current) {
      drawMiniFood(canvasRef.current, type);
    }
  }, [type]);
  return (
    <li className="legend-item">
      <canvas ref={canvasRef} width={30} height={30} className="legend-canvas" />
      <span className="legend-text"><strong>{label}</strong> — {desc}</span>
    </li>
  );
}

export function StartScreen(): JSX.Element {
  const settings = useGameStore((s) => s.settings);
  const newGame = useGameStore((s) => s.newGame);
  const setSoundEnabled = useGameStore((s) => s.setSoundEnabled);

  return (
    <div className="start-screen">
      <h1>Scroll Snake</h1>
      <p className="tagline">A vertical-scrolling snake with momentum.</p>
      <div className="stats">
        <div>High Score: <strong>{settings.highScore}</strong></div>
        <div>Longest Run: <strong>{settings.longestRun}</strong></div>
        <div>Furthest: <strong>Level {settings.furthestLevel}</strong></div>
      </div>
      <button className="primary" onClick={newGame}>Play</button>
      <button className="secondary" onClick={() => setSoundEnabled(!settings.soundEnabled)}>
        Sound: {settings.soundEnabled ? 'ON' : 'OFF'}
      </button>
      <div className="biome-list">
        <h2>Biomes</h2>
        <ul>
          {BIOME_ORDER.map((b) => (
            <li key={b}>{BIOME_DISPLAY[b]}</li>
          ))}
        </ul>
      </div>
      <div className="biome-list legend-section">
        <h2>Food</h2>
        <ul className="legend-list">
          <FoodLegendItem type="NORMAL" label="Normal Food" desc="Yellow ball — +10×combo pts, +1 segment" />
          <FoodLegendItem type="GOLDEN" label="Golden Food" desc="Gold ball (larger, glowing) — +50×combo pts, +2 segments" />
        </ul>
        <h2>Obstacles</h2>
        <p style={{fontSize: '10px', color: '#aaa', marginBottom: '8px'}}>MEADOW → REEF → LATTICE → MAELSTROM (later biomes = harder)</p>
        <ul className="legend-list">
          <ObstacleLegendItem type="GATE" label="Gate" desc="[Meadow] Wall with gap — go through" color="#ff6b6b" />
          <ObstacleLegendItem type="PULSE_WALL" label="Pulse Wall" desc="[Meadow] Wide wall with narrow gap" color="#6bffb8" />
          <ObstacleLegendItem type="DOUBLE_GATE" label="Double Gate" desc="[Meadow] Two walls with offset gaps" color="#ff9999" />
          <ObstacleLegendItem type="LOG" label="Log" desc="[Meadow] Rotating log" color="#cc8855" />
          <ObstacleLegendItem type="CORAL_SPIRE" label="Coral Spire" desc="[Meadow] Tall rock pillar" color="#ff8866" />
          <ObstacleLegendItem type="KELP_CURTAIN" label="Kelp Curtain" desc="[Reef] Vertical bars with gaps" color="#44cc66" />
          <ObstacleLegendItem type="JELLYFISH" label="Jellyfish" desc="[Reef] Drifting jellyfish" color="#ff99cc" />
          <ObstacleLegendItem type="BEEHIVE" label="Beehive" desc="[Reef] Rotating ring of bees" color="#ffdd66" />
          <ObstacleLegendItem type="PORTAL_WALL" label="Portal Wall" desc="[Lattice] Wall with multiple gaps" color="#aa88ff" />
          <ObstacleLegendItem type="DIAGONAL_BEAM" label="Diagonal Beam" desc="[Lattice] Angled beam" color="#ff7744" />
          <ObstacleLegendItem type="CROSS_GATE" label="Cross Gate" desc="[Lattice] Rotating X pattern" color="#ff5588" />
          <ObstacleLegendItem type="SHIFTING_WALL" label="Shifting Wall" desc="[Maelstrom] Wall with moving gap" color="#ffaa44" />
          <ObstacleLegendItem type="CHAOS_RING" label="Chaos Ring" desc="[Maelstrom] Two sliding ring gaps" color="#ff6688" />
          <ObstacleLegendItem type="COMET" label="Comet" desc="[Maelstrom] Flies in from off-screen" color="#ffcc00" />
        </ul>
      </div>
      <p className="hint">
        Steer: <kbd>A</kbd> / <kbd>←</kbd> or <kbd>D</kbd> / <kbd>→</kbd> ·
        Tap the left or right half of the screen ·
        <kbd>Space</kbd>/<kbd>P</kbd> pause ·
        <kbd>R</kbd> reset ·
        <kbd>Q</kbd> quit
      </p>
      <p className="hint" style={{marginTop: '8px', fontSize: '11px'}}>
        Collect food to grow · Chain combos for multipliers · Golden food gives bonus points and segments
      </p>
    </div>
  );
}
